import { render } from "./ModalGestorArchivo.vue?vue&type=template&id=6e41ded4"
import script from "./ModalGestorArchivo.vue?vue&type=script&lang=js"
export * from "./ModalGestorArchivo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__